import type { IconData } from '@stacksjs/iconify-core'

export const visualBlind: IconData = {
  "body": "<g fill=\"none\" stroke-width=\"3\"><path fill=\"#fff\" d=\"M2.3 24.901a3.37 3.37 0 0 1 0-1.802C4.88 13.815 13.394 7 23.5 7s18.62 6.814 21.2 16.099c.163.59.163 1.212 0 1.802C42.12 34.185 33.606 41 23.5 41S4.88 34.186 2.3 24.901\"/><path fill=\"#8fbffa\" d=\"M13.5 24a10 10 0 1 0 20 0a10 10 0 1 0-20 0\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M2.3 24.901a3.37 3.37 0 0 1 0-1.802C4.88 13.815 13.394 7 23.5 7s18.62 6.814 21.2 16.099c.163.59.163 1.212 0 1.802C42.12 34.185 33.606 41 23.5 41S4.88 34.186 2.3 24.901\"/><path stroke=\"#2859c5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M13.5 24a10 10 0 1 0 20 0a10 10 0 1 0-20 0m6-4l8 8m0-8l-8 8\"/></g>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default visualBlind
